<template>
  <v-card>
    <v-form @submit.prevent="submitEditUserPassword()" ref="editUserPasswordForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit Password'" :details="`${user.name} (${user.userAuthClass.name})`"></dialog-header>
          <v-flex xs12 sm6>
            <v-text-field
              type="password"
              label="* Password"
              v-model="editedUser.password"
              :rules="passwordRules"
              :error-messages="passwordsMatchErrorMessage"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              type="password"
              label="* Confirm Password"
              v-model="editedUser.confirmedPassword"
              :rules="passwordRules"
              :error-messages="passwordsMatchErrorMessage"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-btn :color="primaryGrey" flat @click="discard()">Cancel</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import UserService from "@/services/requests/userService";

// MIXINS
import UserValidation from "@/services/validation/userValidation";
import PasswordMatch from "./passwordMatch";

// COMPONENTS
import DialogHeader from "@/components/ui/dialogHeader";

export default {
  mixins: [UserValidation, PasswordMatch],
  components: {
    DialogHeader
  },
  data() {
    return {
      editedUser: Object.assign({}, this.user),
      loading: false,
      prefix: "editedUser"
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedUser = Object.assign({}, this.user);
      this.close();
    },
    submitEditUserPassword() {
      if (!this.$refs.editUserPasswordForm.validate()) {
        return;
      }
      this.save();
    },
    save() {
      this.loading = true;
      UserService.updateUserPassword(this.editedUser)
        .then(result => {
          this.loading = false;
          this.editedUser = Object.assign({}, this.user);
          this.snack({ color: "green", text: "User password was updated" });
          this.close();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.snackError();
        });
    }
  },
  computed: {
    different() {
      if (!this._.isEqual(this.user, this.editedUser)) {
        return true;
      } else {
        return false;
      }
    },

    userAuthClasses: Store.getSet({ store: "users", prop: "userAuthClasses" }),
    passwordConfirmationDialog: Store.getSet({
      store: "users",
      prop: "passwordConfirmationDialog"
    })
  },
  props: {
    user: Object
  },
};
</script>

<style>
</style>
